<template>
    <div class="form-group">
        <label for="">
            <span class="label-title">{{fieldData.label}}</span>
            <span v-if="fieldData.required" class="required-field">*</span>
        </label>
        <input-summernote :model.sync="fieldData.value"></input-summernote>
    </div>
</template>

<script>
import FormSummernote from '../form/form-summernote.vue';

export default {
    name: 'Form-wysiwyg',
    props: {
        fieldData: Object
    },
    components: {
        'input-summernote': FormSummernote,
    },
    mounted() {

    }
}
</script>